// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3Shsc","footer":"ModalCreateQualiphyProcedure_footer__nerai","additionData":"ModalCreateQualiphyProcedure_additionData__2Vje6"};